import { useTunnusContext } from 'contexts/TunnusContext';

export const useYleSk = () => {
  return useTunnusContext()?.user?.userId;
};
